import { render, staticRenderFns } from "./VariantForm.vue?vue&type=template&id=1a26e1de&scoped=true"
import script from "./VariantForm.vue?vue&type=script&lang=js"
export * from "./VariantForm.vue?vue&type=script&lang=js"
import style0 from "./VariantForm.vue?vue&type=style&index=0&id=1a26e1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a26e1de",
  null
  
)

export default component.exports